import request from '@/helpers/request';

export function list(data) {
  return request.request({
    url: '/users',
    method: 'get',
    data: data,
  });
}

export function getInfo() {
  return request.request({
    url: '/users/info',
    method: 'get',
  });
}

export function update(data) {
  return request.request({
    url: '/users/update',
    method: 'put',
    data: data,
  });
}

export function getWidgets(staff, range) {
  return request.request({
    url: '/users/widgets/' + staff,
    method: 'get',
    data: { 'range': range },
  });
}

export function getStaffSales(staff) {
  return request.request({
    url: '/users/staff-sales/' + staff,
    method: 'get',
  });
}

export function getRecentSales(type, data) {
  return request.request({
    url: '/users/staff-recent/' + type,
    method: 'get',
    data: data,
  });
}
